export default __webpack_public_path__ + "static/media/matt.5ae6612b.png";